/**
 * @ngdoc service
 * @name externalRedirect
 *
 * @description
 * redirect to a resource outside of the module scope
 *
 * @param {$window} $window
 *
 * @ngInject
 */
function externalRedirect($window) {

    return {
        redirect
    };

    /**
     * @ngdoc method
     * @name externalRedirect#redirect
     *
     * @param {string} redirectUrl
     */
    function redirect(redirectUrl) {
        $window.location.href = redirectUrl;
    }

}

export default externalRedirect;



/** WEBPACK FOOTER **
 ** ./src/main/assets/app/common/services/externalRedirect.js
 **/